exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.crop-container {\n  background-size: contain;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n.crop-container .slim {\n    background-color: rgba(0, 0, 0, 0);\n}\n.shrink img {\n  max-height: 11rem;\n}\n", ""]);

// exports
